__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@hopin-team/application-schedule-widget";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@slicesjs/core", "2.3.0", () => (__webpack_require__.e(518).then(() => (() => (__webpack_require__(3518))))));
			register("@slicesjs/react-core", "2.4.0", () => (Promise.all([__webpack_require__.e(226), __webpack_require__.e(12), __webpack_require__.e(181)]).then(() => (() => (__webpack_require__(1181))))));
			register("@slicesjs/react-router-app", "2.3.0", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(226), __webpack_require__.e(122), __webpack_require__.e(903), __webpack_require__.e(475)]).then(() => (() => (__webpack_require__(1475))))));
			register("@slicesjs/reactive-map", "1.0.13", () => (__webpack_require__.e(689).then(() => (() => (__webpack_require__(689))))));
			register("@slicesjs/reactive-map", "1.0.13", () => (__webpack_require__.e(676).then(() => (() => (__webpack_require__(3676))))));
			register("polished", "4.2.2", () => (Promise.all([__webpack_require__.e(250), __webpack_require__.e(462)]).then(() => (() => (__webpack_require__(6250))))));
			register("react-dom", "18.1.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(226)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(102), __webpack_require__.e(226)]).then(() => (() => (__webpack_require__(102))))));
			register("react", "18.1.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			register("styled-components", "5.0.0", () => (Promise.all([__webpack_require__.e(163), __webpack_require__.e(226)]).then(() => (() => (__webpack_require__(9163))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};